/* eslint-disable react/no-multi-comp */
import React, { useContext, useMemo } from 'react';
import * as R from 'ramda';

import { Flex, LoadingDots } from '@app/ui';
import GameView from './GameView';
import useGenderBreakdownByGame from '../../../../components/hooks/inVenue/useGenderBreakdownByGame';
import { InVenueContext } from '../../../InVenue.context';
import GenderLegend from '../../common/GenderLegend';

const GenderBreakdownByGame = () => {
    const {
        client,
        current: { rightsholder, season, gameDates, sections },
        isLoadingFilters,
    } = useContext(InVenueContext);

    const { data: genderBreakdownByGame, isLoading: isLoadingAnalytics } =
        useGenderBreakdownByGame({
            clientId: client.id,
            rightsholder,
            season,
            gameDates,
            sectionIds: sections.map(section => section.id),
        });

    const hasNoData = R.isEmpty(genderBreakdownByGame);
    const isLoading = isLoadingFilters || isLoadingAnalytics;

    const games = useMemo(
        () =>
            Object.entries(genderBreakdownByGame).sort(
                ([dateA], [dateB]) =>
                    new Date(dateB).getTime() - new Date(dateA).getTime(),
            ),
        [genderBreakdownByGame],
    );

    return (
        <Flex
            vertical
            className="gds-layout__container stadium-attendance-chart-container stadium-attendance-chart-container-gender stadium-attendance-card "
        >
            {!isLoading && (
                <>
                    <div className="stadium-attendance-game-container-wrapper">
                        <div className="stadium-attendance-game-container-overflow">
                            <div className="stadium-attendance-game-container">
                                {!hasNoData &&
                                    games.map(([date, analytics]) => {
                                        return (
                                            <GameView
                                                key={`genderbreakdownbydate-${date}`}
                                                date={date}
                                                analytics={analytics}
                                            />
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                    <GenderLegend isLoading={isLoading} />
                </>
            )}
            {isLoading && <LoadingDots />}
        </Flex>
    );
};

export default GenderBreakdownByGame;
